import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';
import throttle from 'lodash/throttle';

@Directive({
  selector: '[scrollPercent]',
})
export class ScrollPercentDirective implements AfterViewInit {
  @Input('scrollPercent') private scrollPercent: string;
  private el: HTMLElement;
  private className = 'scroll-percent';
  private currentClasses = '';
  @HostListener('scroll') private updateClassThrottled = throttle(this.updateClass, 300);

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  public ngAfterViewInit() {
    if (this.scrollPercent) this.className = this.scrollPercent;
    this.currentClasses = this.el.className;
  }

  private updateClass() {
    const newClass = Number((this.el.scrollTop / (this.el.scrollHeight - this.el.offsetHeight)) * 100).toFixed(0);
    this.el.className = `${this.currentClasses} ${this.className}-${newClass}`;
  }
}
